import { render, staticRenderFns } from "./EmailVerificationPage.vue?vue&type=template&id=11d10211&scoped=true"
import script from "./EmailVerificationPage.vue?vue&type=script&lang=js"
export * from "./EmailVerificationPage.vue?vue&type=script&lang=js"
import style0 from "./EmailVerificationPage.vue?vue&type=style&index=0&id=11d10211&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11d10211",
  null
  
)

export default component.exports